import { SelectedShippingRate } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";

export function getScanSelectedRateComparison(
  initial: SelectedShippingRate | null | undefined,
  purchased: SelectedShippingRate,
) {
  const selectedRateAtScanLoad = initial
    ? {
        carrier: initial.carrier,
        service: initial.service,
        carrier_account_id: initial.carrier_account_id ?? null,
      }
    : null;
  const purchasedRate = {
    carrier: purchased.carrier,
    service: purchased.service,
    carrier_account_id: purchased.carrier_account_id ?? null,
  };

  return {
    selectedRateAtScanLoad,
    purchasedRate,
    hadSelectedRateAtScanLoad: initial === undefined ? null : initial !== null,
    selectedRateMatchesScanLoad: selectedRateAtScanLoad
      ? selectedRateAtScanLoad.carrier === purchasedRate.carrier &&
        selectedRateAtScanLoad.service === purchasedRate.service &&
        selectedRateAtScanLoad.carrier_account_id ===
          purchasedRate.carrier_account_id
      : null,
  };
}
